export type TargetFn<A, R> = (args: A) => R;
export type DebouncedFn<A, R> = (args: A) => Promise<R>;
export type DestructorFn = () => void;

export function debounce<A, R>(fn: TargetFn<A, R>, timeout: number): [DebouncedFn<A, R>, DestructorFn] {
	let timer: number = -1;

	const destructor = () => {
		if (timer >= 0) {
			window.clearTimeout(timer);
			timer = -1;
		}
	};

	const debounced = (args: A): Promise<R> => new Promise((resolve) => {
		destructor();

		timer = window.setTimeout(() => {
			resolve(fn(args));
		}, timeout);
	});

	return [debounced, destructor];
}
